import React from 'react';
import Header from '../Header';
import ImageAccordion from '../ImageAccordion';
import Footer from '../Footer';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home-container">
      <div className="gradient-overlay"></div>
      <div className="floating-accent"></div>
      
      <Header />
      
      <main className="main-content">
        
        <section className="accordion-section">
          <ImageAccordion />
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default Home;